const Box = {}
// Franchement je sais pas trop ce qu'on viendra mettre ici
export default Box
